<div class="stick-top">
  <mat-toolbar>
    <mat-icon>leaderboard</mat-icon> SA Lock Statistics
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" type="button" (click)="loadStats()">
      <mat-icon>refresh</mat-icon> Refresh
    </button>
  </div>
</div>

<div class="padded">
  <form #form="ngForm" role="form" class="vbox">
    <table class="basicTable vtable">
      <thead>
      <tr>
        <th colspan="100">Lock Statistics</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <th>Company</th>
        <td>
          <micro-company-select *ngIf="authService.isCompanyAdmin()" [(companyId)]="companyId" [jump]="false" (valueChange)="onCompanyIdChanged()"  id="companyId" name="companyId"></micro-company-select>
          <micro-company-lookup *ngIf="!authService.isCompanyAdmin()" [companyId]="companyId"></micro-company-lookup>
        </td>
      </tr>

      <tr>
        <th colspan="100" class="text-center">Lock Controllers</th>
      </tr>
      <tr>
        <th>V1 Registered</th>
        <td>{{stats.controllerCountRegV1}}</td>
      </tr>
      <tr>
        <th>V2 Registered</th>
        <td>{{stats.controllerCountRegV2}}</td>
      </tr>
      <tr>
        <th>Total Registered</th>
        <td>{{stats.controllerCountReg}}</td>
      </tr>
      <tr>
        <th>Controllers Other</th>
        <td>{{stats.controllerCountTotal - stats.controllerCountReg}}</td>
      </tr>
      <tr>
        <th>Total Controllers</th>
        <td>{{stats.controllerCountTotal}}</td>
      </tr>
      <tr>
        <th colspan="100" class="text-center">Locks</th>
      </tr>
      <tr>
        <th>V1 Registered</th>
        <td>{{stats.lockCountV1Reg}}</td>
      </tr>
      <tr>
        <th>V1 Other</th>
        <td>{{stats.lockCountV1Total - stats.lockCountV1Reg}}</td>
      </tr>
      <tr>
        <th>V1 Total</th>
        <td>{{stats.lockCountV1Total}}</td>
      </tr>
      <tr>
        <th>V2 Registered</th>
        <td>{{stats.lockCountV2Reg}}</td>
      </tr>
      <tr>
        <th>V2 Other</th>
        <td>{{stats.lockCountV2Total - stats.lockCountV2Reg}}</td>
      </tr>
      <tr>
        <th>V2 Total</th>
        <td>{{stats.lockCountV2Total}}</td>
      </tr>
      <tr>
        <th>Total Locks</th>
        <td>{{stats.lockCountTotal}}</td>
      </tr>
      <tr>
        <th>Level 1 Locks</th>
        <td>{{stats.lockCountV1Reg + stats.lockCountV2RegLevel1}}</td>
      </tr>
      <tr>
        <th>Level 2 Locks</th>
        <td>{{stats.lockCountV2RegLevel2}}</td>
      </tr>
      </tbody>
    </table>
  </form>
</div>

